import React from "react";

import {
    Document,
    Page,
    Text,
    View,
    Image,
    Svg,
    Line,
    Polygon,
    Rect,
    StyleSheet,
    pdf
} from "@react-pdf/renderer";

import JSZip from "jszip";
import { saveAs } from "file-saver";

import SCHOOL_LOGO from "./savationChristLogo.png";


/*
|--------------------------------------------------------------------------
| SCHOOL INFORMATION
|--------------------------------------------------------------------------
*/

// const SCHOOL_NAME = "JANA L. WILLIAMS EDUCATIONAL FOUNDATION";
// const SCHOOL_ADDRESS = "MT. BARCLAY NEW STORE COMMUNITY, MONTSERRADO COUNTY, LIBERIA";
const SCHOOL_NAME = "SALVATION IN CHRIST SCHOOL SYSTEM";
const SCHOOL_ADDRESS = "Zazay Community, Paynesville City, Monrovia";



/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

const getDisplayValue = (value) => {
    if (value === null || value === undefined) {
        return "";
    }

    if (typeof value === "object") {
        return (
            value.name ||
            value.title ||
            value.label ||
            ""
        );
    }

    return String(value);
};


const getStudentName = (student) => {
    return (
        getDisplayValue(student?.full_name) ||
        getDisplayValue(student?.name) ||
        "Student Name"
    );
};


const getClassName = (gradeClass) => {
    return (
        getDisplayValue(gradeClass?.name) ||
        "Graduating Class"
    );
};


const getDivision = (gradeClass) => {
    return getDisplayValue(
        gradeClass?.division
    );
};


const getAcademicYear = (academicYear) => {
    return (
        getDisplayValue(
            academicYear?.name
        ) || ""
    );
};


/*
|--------------------------------------------------------------------------
| SVG COMPONENTS
|--------------------------------------------------------------------------
*/


const OrangeCorner = ({
    position = "top-left"
}) => {

    return (
        <Svg width="130" height="130">

            <Polygon
                points={
                    position === "top-left"
                    ? "0,0 130,0 0,130"
                    : "130,0 130,130 0,130"
                }
                fill="#E65F00"
                opacity="0.12"
            />

            <Line
                x1="20"
                y1="20"
                x2="110"
                y2="110"
                stroke="#E65F00"
                strokeWidth="3"
            />

        </Svg>
    );
};


const BlackDivider = () => {

    return (
        <Svg width="250" height="10">

            <Line
                x1="0"
                y1="5"
                x2="250"
                y2="5"
                stroke="#111111"
                strokeWidth="1"
            />

        </Svg>
    );
};


const OrangeAccentBar = () => {

    return (
        <Svg width="80" height="8">

            <Rect
                width="80"
                height="8"
                fill="#E65F00"
            />

        </Svg>
    );
};
const styles = StyleSheet.create({

    page:{
        width:"100%",
        height:"100%",
        backgroundColor:"#FFF9F0",
        fontFamily:"Helvetica",
        position:"relative"
    },

    topCorner:{
        position:"absolute",
        top:0,
        left:0
    },

    bottomCorner:{
        position:"absolute",
        bottom:0,
        right:0,
        transform:[
            "rotate(180deg)"
        ]
    },

    container:{
        position:"absolute",
        top:45,
        left:55,
        right:55,
        bottom:45
    },

    outerBorder:{
        width:"100%",
        height:"100%",
        borderWidth:1,
        borderColor:"#111111",
        padding:12
    },

    innerBorder:{
        width:"100%",
        height:"100%",
        borderWidth:1,
        borderColor:"#E65F00",
        padding:45,
        alignItems:"center",
        justifyContent:"center",
        position:"relative"
    },


    logo:{
        width:75,
        height:75,
        marginBottom:12
    },


    schoolName:{
        fontSize:18,
        fontWeight:"bold",
        color:"#111111",
        letterSpacing:2,
        textAlign:"center"
    },


    address:{
        fontSize:8,
        color:"#555555",
        marginTop:5,
        letterSpacing:1
    },


    certificateType:{
        marginTop:20,
        fontSize:12,
        color:"#E65F00",
        fontWeight:"bold",
        letterSpacing:3
    },


    title:{
        marginTop:8,
        fontSize:38,
        fontWeight:"bold",
        color:"#111111",
        letterSpacing:2
    },


    bodyText:{
        marginTop:15,
        fontSize:12,
        color:"#333333",
        textAlign:"center",
        lineHeight:1.5
    },


    studentName:{
        marginTop:15,
        fontSize:32,
        color:"#E65F00",
        fontWeight:"bold",
        letterSpacing:1.5
    },


    classText:{
        marginTop:12,
        fontSize:18,
        color:"#111111",
        fontWeight:"bold"
    },


    yearText:{
        marginTop:8,
        fontSize:14,
        color:"#555555"
    },


    footer:{
        position:"absolute",
        bottom:35,
        left:70,
        right:70,
        flexDirection:"row",
        justifyContent:"space-between"
    },


    signatureBox:{
        width:150,
        alignItems:"center"
    },


    signatureLine:{
        width:130,
        borderTopWidth:1,
        borderColor:"#111111",
        marginBottom:6
    },


    signatureName:{
        fontSize:10,
        fontWeight:"bold"
    },


    signatureRole:{
        fontSize:8,
        color:"#E65F00"
    },


    certificateNumber:{
        position:"absolute",
        bottom:10,
        fontSize:8,
        color:"#777777"
    }

});

const CertificatePage = ({
    student,
    gradeClass,
    academicYear
}) => {

    const studentName = getStudentName(student);

    const className = getClassName(gradeClass);

    const division = getDivision(gradeClass);

    const year = getAcademicYear(academicYear);


    return (

        <Document>

            <Page
                size="A4"
                orientation="landscape"
                style={styles.page}
            >


                <View style={styles.topCorner}>

                    <OrangeCorner
                        position="top-left"
                    />

                </View>



                <View style={styles.bottomCorner}>

                    <OrangeCorner
                        position="bottom-right"
                    />

                </View>




                <View style={styles.container}>


                    <View style={styles.outerBorder}>


                        <View style={styles.innerBorder}>


                            <Image
                                src={SCHOOL_LOGO}
                                style={styles.logo}
                            />



                            <Text style={styles.schoolName}>
                                {SCHOOL_NAME}
                            </Text>



                            <Text style={styles.address}>
                                {SCHOOL_ADDRESS}
                            </Text>




                            <Text style={styles.certificateType}>
                                CERTIFICATE OF GRADUATION
                            </Text>




                            <Text style={styles.title}>
                                Certificate
                            </Text>




                            <OrangeAccentBar />





                            <Text style={styles.bodyText}>
                                This certificate is proudly presented to
                            </Text>





                            <Text style={styles.studentName}>
                                {studentName}
                            </Text>





                            <BlackDivider />






                            <Text style={styles.bodyText}>
                                In recognition of successfully completing
                                the required academic program and meeting
                                all graduation requirements.
                            </Text>







                            <Text style={styles.classText}>

                                {className}

                                {
                                    division &&
                                    ` - ${division}`
                                }

                            </Text>






                            <Text style={styles.yearText}>
                                Academic Year {year}
                            </Text>







                            <View style={styles.footer}>



                                <View style={styles.signatureBox}>


                                    <View style={styles.signatureLine}/>



                                    <Text style={styles.signatureName}>
                                        Principal
                                    </Text>



                                    <Text style={styles.signatureRole}>
                                        School Administration
                                    </Text>


                                </View>








                                <View style={styles.signatureBox}>


                                    <View style={styles.signatureLine}/>



                                    <Text style={styles.signatureName}>
                                        Registrar
                                    </Text>



                                    <Text style={styles.signatureRole}>
                                        Academic Records
                                    </Text>


                                </View>




                            </View>








                            <Text style={styles.certificateNumber}>

                                Certificate No:
                                {" "}
                                SIC-
                                {year}-
                                {student?.id || "001"}

                            </Text>





                        </View>


                    </View>


                </View>



            </Page>


        </Document>

    );

};
const GraduateCertificatePDF = {


    /*
    |--------------------------------------------------------------------------
    | DOWNLOAD SINGLE CERTIFICATE
    |--------------------------------------------------------------------------
    */


    downloadSingle: async (
        student,
        gradeClass,
        academicYear
    ) => {


        const blob = await pdf(

            <CertificatePage
                student={student}
                gradeClass={gradeClass}
                academicYear={academicYear}
            />

        ).toBlob();




        const fileName =
            `${getStudentName(student)
                .replace(
                    /\s+/g,
                    "_"
                )
            }_Graduation_Certificate.pdf`;




        saveAs(
            blob,
            fileName
        );


    },






    /*
    |--------------------------------------------------------------------------
    | DOWNLOAD MULTIPLE CERTIFICATES
    | ZIP FILE
    |--------------------------------------------------------------------------
    */


    downloadMultiple: async (
        students,
        gradeClass,
        academicYear
    ) => {


        const zip = new JSZip();




        for (
            const student of students
        ) {



            const blob = await pdf(


                <CertificatePage
                    student={student}
                    gradeClass={gradeClass}
                    academicYear={academicYear}
                />


            ).toBlob();






            const fileName =
                `${getStudentName(student)
                    .replace(
                        /\s+/g,
                        "_"
                    )
                }_Graduation_Certificate.pdf`;






            zip.file(
                fileName,
                blob
            );



        }







        const zipBlob =
            await zip.generateAsync({

                type:"blob"

            });







        saveAs(

            zipBlob,

            // "Salvation_In_Christ_Graduation_Certificates.zip"
            "Zion_Praise_Academy_Graduation_Certificates.zip"

        );


    }



};





export default GraduateCertificatePDF;
